import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

export interface FilterDropdownOption {
  value: string;
  label: string;
  /**
   * Option ist waehlbar, aber nicht anklickbar. Das Design nutzt es fuer
   * spaeter freigeschaltete Systeme (page-testresultate.jsx:129,
   * „<Name> — folgt spaeter"). Default: false.
   */
  disabled?: boolean;
}

@Component({
  selector: 'app-filter-dropdown',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './filter-dropdown.component.html',
  styleUrl: './filter-dropdown.component.scss',
})
export class FilterDropdownComponent {
  readonly value = input<string>('');
  /**
   * Dient gleichzeitig als Text der Placeholder-Option und als zugaenglicher
   * Name (aria-label) des Selects. Pflicht — sonst rendert das Kombinationsfeld
   * ohne Namen (WCAG 2.1 SC 4.1.2, fboudouhi Blocker 1).
   */
  readonly placeholder = input.required<string>();
  readonly options = input<FilterDropdownOption[]>([]);
  readonly disabled = input<boolean>(false);
  readonly name = input<string | undefined>(undefined);

  readonly valueChange = output<string>();

  readonly testId = computed(() => {
    const suffix = this.name()?.trim();
    return suffix ? `filter-dropdown-${suffix}` : 'filter-dropdown';
  });

  onChange(next: string): void {
    this.valueChange.emit(next);
  }
}
